import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import crumbContext from "contexts/crumbs"
function Breadcrumb(props) {
    const {selected} = props
    const {crumbs, setCrumbs} = useContext(crumbContext)
    function isLast(index) {
        return index === crumbs.length - 1;
    }
    const deleteCrumbs = (crumb) => {
        const oldCrumbs = [...crumbs]
        const toDelete = oldCrumbs.indexOf(crumb)
        oldCrumbs.splice(toDelete +1 )
        setCrumbs(oldCrumbs)
    }
    return (
        <nav className="">
            <ul className="breadcrumb flex">
                {
                    crumbs.map((crumb, ci) => {
                        const disabled = isLast(ci) ? 'disabled' : '';
                        
                        return (
                                <Link to={crumb.page}
                                    key={ ci }
                                    className="breadcrumb-item align-items-center"
                                    onClick={() => {
                                        deleteCrumbs(crumb)
                                    }}
                                >
                                    <div className={ ` ${ disabled }` }>
                                        {
                                            ci !== 0 && <>&nbsp;/&nbsp;</>
                                        } 
                                        { crumb.title }
                                    </div>
                                </Link>
                            );
                    })
                }
            </ul>
        </nav>
    );
}

export default Breadcrumb;